import React from "react";
import { useSelector } from "react-redux";
import { selectCityIsLoading } from "../../redux/state/citiesReduser/cities.redusers";
import CitiesList from "../../Components/CitiesList/CitiesList";
import Loader from "../../Components/Loader/Loader";

const Home = () => {
  
  const isLoading = useSelector(selectCityIsLoading);
  if (isLoading) <Loader />

  return (
      <CitiesList />
  );
};

export default Home;
